import { createSlice } from "@reduxjs/toolkit";
import { getAllBillListing, getBilling, getBillingDetail, getChequeDetail, getNewMemberBillings, newMemberDetail } from "../Actions/BillingsActions";

const initialState = {
    isLoading: false,
    getttingBillingData: [],
    getAllBillingData: [],
    getBillingDetail: [],
    chequeDetail: [],
    memberNewBillings: [],
    newMemberBillingDetails: []
};

const BillingDataSlice = createSlice({
    name: "billingSlice",
    initialState,

    extraReducers: (bulider) => {
        bulider.addCase(getBilling.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(getBilling.fulfilled, (state, action) => {
            state.isLoading = false;
            state.getttingBillingData = action?.payload; // take array list for getting data 
        });
        bulider.addCase(getBilling.rejected, (state, action) => {
            state.isLoading = false;
        });

        // All Billing Listing

        bulider.addCase(getAllBillListing.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(getAllBillListing.fulfilled, (state, action) => {
            state.isLoading = false;
            state.getAllBillingData = action?.payload; // take array list for getting data 
        });
        bulider.addCase(getAllBillListing.rejected, (state, action) => {
            state.isLoading = false;
        });

        // billing detail
        bulider.addCase(getBillingDetail.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(getBillingDetail.fulfilled, (state, action) => {
            state.isLoading = false;
            state.getBillingDetail = action?.payload; // take array list for getting data 
        });
        bulider.addCase(getBillingDetail.rejected, (state, action) => {
            state.isLoading = false;
        });

        // cheque detail
        bulider.addCase(getChequeDetail.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(getChequeDetail.fulfilled, (state, action) => {
            state.isLoading = false;
            state.chequeDetail = action?.payload; // take array list for getting data 
        });
        bulider.addCase(getChequeDetail.rejected, (state, action) => {
            state.isLoading = false;
        });

        // get new member billings
        bulider.addCase(getNewMemberBillings.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(getNewMemberBillings.fulfilled, (state, action) => {
            state.isLoading = false;
            state.memberNewBillings = action?.payload; // take array list for getting data 
        });
        bulider.addCase(getNewMemberBillings.rejected, (state, action) => {
            state.isLoading = false;
        });

        // get new member billings detail
        bulider.addCase(newMemberDetail.pending, (state, action) => {
            state.isLoading = true;
        });
        bulider.addCase(newMemberDetail.fulfilled, (state, action) => {
            state.isLoading = false;
            state.newMemberBillingDetails = action?.payload; // take array list for getting data 
        });
        bulider.addCase(newMemberDetail.rejected, (state, action) => {
            state.isLoading = false;
        });

    }
})

export default BillingDataSlice.reducer;